import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label";
import { Select, TSelectOption } from "@/components/forms/Select";

type TAgentFilter = {
  onPeriod: (value: string) => void;
  selVal?: string;
  hideSelectDate?: boolean;
  showThisWeek?: boolean;
};

type TTimePeriodOption = {
  value: string;
  label: string;
};

const WeeklyPeriodDrodown = ({
  onPeriod,
  selVal,
  hideSelectDate,
  showThisWeek,
}: TAgentFilter) => {
  const { t } = useTranslation(["common", "overAllSentimentAnalysisPage"]);

  const timePeriodOptions: TTimePeriodOption[] = useMemo(() => {
    const options = [
      ...(showThisWeek
        ? [
            {
              value: "this-week",
              label: t(
                "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.THIS_WEEK",
                "This Week",
              ),
            },
          ]
        : []),
      {
        value: "last-week",
        label: t("overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.LAST_WEEK"),
      },
      {
        value: "last-month",
        label: t(
          "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.LAST_MONTH",
        ),
      },
      {
        value: "week-2",
        label: t(
          "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.TWO_WEEKS_AGO",
        ),
      },
      {
        value: "week-3",
        label: t(
          "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.THREE_WEEKS_AGO",
        ),
      },
      {
        value: "month-2",
        label: t(
          "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.TWO_MONTHS_AGO",
        ),
      },
      {
        value: "month-3",
        label: t(
          "overAllSentimentAnalysisPage:FILTERS.TIME_PERIODS.THREE_MONTHS_AGO",
        ),
      },
      {
        value: "select-customize-date",
        label: "Select Date",
      },
    ];

    if (hideSelectDate) {
      return options.filter((opt) => opt.value !== "select-customize-date");
    }
    return options;
  }, [showThisWeek, t, hideSelectDate]);
  const [selPeriod, setSelPeriod] = useState(t("FILTER.PERIOD"));

  // Agent change event
  const handlePeriodClick = (item: { label: string; value: string }) => {
    setSelPeriod(item.label);
    onPeriod(item.value);
  };

  useEffect(() => {
    if (selVal) {
      const obj = timePeriodOptions?.find((item) => item?.value === selVal);
      if (obj?.label) {
        setSelPeriod(obj.label);
      }
    } else {
      // Default to "this-week" if available, else "last-week"
      const defaultOption = showThisWeek
        ? (timePeriodOptions.find((opt) => opt.value === "this-week") ??
          timePeriodOptions[0])
        : timePeriodOptions[0];

      if (defaultOption) {
        setSelPeriod(defaultOption.label);
        onPeriod(defaultOption.value);
      }
    }
  }, [onPeriod, selVal, showThisWeek, timePeriodOptions]);

  return (
    <>
      <div>
        <Label weight={"medium"} className="mb-1">
          {t("FILTER.PERIOD")}
        </Label>
        <Select
          name="period"
          options={timePeriodOptions}
          value={
            timePeriodOptions?.find((item) => item.label === selPeriod) ?? null
          }
          onChange={(option: TSelectOption) => handlePeriodClick(option)}
          getOptionLabel={(option: TSelectOption) => option.label}
          getOptionValue={(option: TSelectOption) => option.value}
          placeholder={t("FILTER.SELECT_PERIOD")}
          className="text-sm"
          isClearable={false}
        />
      </div>
    </>
  );
};
export default WeeklyPeriodDrodown;
